import {
    LAYOUT_SET_TRANSLATIONS,
    LAYOUT_SET_CSRF_TOKEN,
    LAYOUT_SET_CONFIG
} from './actions';

const initialState = {
    trans: '',
    csrf_token: '',
    config: ''
};

export const layoutReducer = ( state = initialState, action ) => {

    let result = '';

    switch ( action.type ) {

        case LAYOUT_SET_TRANSLATIONS:
            result = { ...state, trans: action.payload };
            break;

        case LAYOUT_SET_CSRF_TOKEN:
            result = { ...state, csrf_token: action.payload };
            break;

        case LAYOUT_SET_CONFIG:
            result = { ...state, config: action.payload };
            break;

        default:
            return state;

    }

    return result;

};